import {
    GET_SESSION_USER_DETAIL_REQUEST,
    GET_SESSION_USER_DETAIL_SUCCESS,
    GET_SESSION_USER_DETAIL_FAILURE
} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    userDetail: {},
    error: null,
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_SESSION_USER_DETAIL_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_SESSION_USER_DETAIL_SUCCESS:
            console.log('disptach success, ', action.payload)
            return {
                ...state,
                isLoading: false,
                userDetail: {...action.payload.userDetail},
                isInitialFetch: false,
            };
        case GET_SESSION_USER_DETAIL_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        default:
            return state;
    }
};